import React from 'react';
import { CheckCircle, Target, Heart, Shield } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';

const AboutPage = () => {
  const { language } = useLanguage();
  const t = translations[language] || translations.pt;

  return (
    <div className="min-h-screen" data-testid="about-page">
      <section className="py-16 md:py-24 bg-gradient-to-b from-primary to-primary-dark text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold mb-6">
            {t.about.title}
          </h1>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose max-w-none">
            <p className="text-lg leading-relaxed text-gray-700 font-body mb-8">
              {t.about.story}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mt-16">
            <div className="bg-gray-50 p-8 rounded-xl" data-testid="mission-section">
              <div className="flex items-center mb-4">
                <Target size={32} className="text-primary mr-3" />
                <h2 className="text-2xl font-heading font-semibold text-gray-900">
                  {t.about.mission.title}
                </h2>
              </div>
              <p className="text-base leading-relaxed text-gray-700 font-body">
                {t.about.mission.description}
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-xl" data-testid="values-section">
              <div className="flex items-center mb-4">
                <Heart size={32} className="text-primary mr-3" />
                <h2 className="text-2xl font-heading font-semibold text-gray-900">
                  {t.about.values.title}
                </h2>
              </div>
              <ul className="space-y-3">
                {t.about.values.list.map((value, index) => (
                  <li key={index} className="flex items-start" data-testid={`value-${index}`}>
                    <CheckCircle size={20} className="text-accent mr-2 mt-1 flex-shrink-0" />
                    <span className="text-base text-gray-700 font-body">{value}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="mt-12 bg-primary text-white p-8 md:p-12 rounded-xl" data-testid="commitment-section">
            <div className="flex items-center mb-6">
              <Shield size={40} className="text-accent mr-4" />
              <h2 className="text-3xl font-heading font-semibold">
                {t.about.commitment.title}
              </h2>
            </div>
            <p className="text-lg leading-relaxed font-body">
              {t.about.commitment.description}
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div data-testid="stat-founded">
              <div className="text-5xl font-heading font-bold text-primary mb-2">2022</div>
              <p className="text-lg text-gray-700 font-body">
                {language === 'pt' ? 'Ano de Fundação' : 'Year Founded'}
              </p>
            </div>
            <div data-testid="stat-clients">
              <div className="text-5xl font-heading font-bold text-primary mb-2">100+</div>
              <p className="text-lg text-gray-700 font-body">
                {language === 'pt' ? 'Clientes Satisfeitos' : 'Satisfied Clients'}
              </p>
            </div>
            <div data-testid="stat-services">
              <div className="text-5xl font-heading font-bold text-primary mb-2">500+</div>
              <p className="text-lg text-gray-700 font-body">
                {language === 'pt' ? 'Serviços Realizados' : 'Services Completed'}
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
